// AUTO-GENERATED - DO NOT EDIT MANUALLY

import { LangDto, UTMDto, IBaseSingleResultDto } from '@skillarea/lib-shared';

import { IRequestOptions, IRequestConfig, getConfigs, axios } from './options';

export const basePath = '';

export class CookiesService {
  /**
   * POST /api/cookie/utm
   */
  saveUTM(
    params: {
      /** requestBody */
      body?: UTMDto;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/cookie/utm';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * POST /api/cookie/lang
   */
  saveLang(
    params: {
      /** requestBody */
      body?: LangDto;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/cookie/lang';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }
}
